<script setup>
import RestrictedAccess from 'Components/pages/EnRestrictedAccess/EnRestrictedAccess.vue';
</script>

<template>
  <restricted-access></restricted-access>
</template>